import { lazy } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";

import { FunnelLayout } from "@/layouts/FunnelLayout";
import { AppLayout } from "@/layouts/AppLayout";
import { RootRedirect } from "@/routes/RootRedirect";

const XhsDiagnosisPage = lazy(() => import("@/pages/XhsDiagnosisPage"));
const DiagnosisPage = lazy(() => import("@/pages/DiagnosisPage"));
const ReportPage = lazy(() => import("@/pages/ReportPage"));
const FreeTrainingPage = lazy(() => import("@/pages/FreeTrainingPage"));
const FreeSummaryPage = lazy(() => import("@/pages/FreeSummaryPage"));
const PricingPage = lazy(() => import("@/pages/PricingPage"));
const XiaoetongReturnPage = lazy(() => import("@/pages/XiaoetongReturnPage"));
const ActivatePage = lazy(() => import("@/pages/ActivatePage"));
const PackStartPage = lazy(() => import("@/pages/PackStartPage"));
const LearnEntryPage = lazy(() => import("@/pages/LearnEntryPage"));
const LoginPage = lazy(() => import("@/pages/LoginPage"));
const RegisterPage = lazy(() => import("@/pages/RegisterPage"));

const AppHomePage = lazy(() => import("@/pages/AppHomePage"));
const PracticePage = lazy(() => import("@/pages/PracticePage"));
const ReviewPage = lazy(() => import("@/pages/ReviewPage"));
const SrsSessionPage = lazy(() => import("@/pages/SrsSessionPage"));
const WeaknessSessionPage = lazy(() => import("@/pages/WeaknessSessionPage"));
const ProfilePage = lazy(() => import("@/pages/ProfilePage"));
const AchievementsPage = lazy(() => import("@/pages/AchievementsPage"));

const DailyMissionPage = lazy(() => import("@/pages/DailyMissionPage"));

const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));

export const router = createBrowserRouter([
  {
    element: <FunnelLayout />,
    children: [
      { path: "/xhs-diagnosis", element: <XhsDiagnosisPage /> },
      { path: "/start", element: <Navigate to="/xhs-diagnosis" replace /> },
      { path: "/diagnosis", element: <DiagnosisPage /> },
      { path: "/report/:id", element: <ReportPage /> },
      { path: "/free-training/:groupId", element: <FreeTrainingPage /> },
      { path: "/free-summary/:groupId", element: <FreeSummaryPage /> },
      { path: "/pricing", element: <PricingPage /> },
      { path: "/return-from-xiaoetong", element: <XiaoetongReturnPage /> },
      { path: "/activate", element: <ActivatePage /> },
      { path: "/pack/:id/start", element: <PackStartPage /> },
      { path: "/learn", element: <LearnEntryPage /> },
      { path: "/login", element: <LoginPage /> },
      { path: "/register", element: <RegisterPage /> },
    ],
  },
  {
    element: <AppLayout />,
    children: [
      { path: "/app", element: <AppHomePage /> },
      { path: "/app/mission", element: <DailyMissionPage /> },
      { path: "/app/practice", element: <PracticePage /> },
      { path: "/app/review", element: <ReviewPage /> },
      { path: "/app/review/srs", element: <SrsSessionPage /> },
      { path: "/app/review/session/:sessionId", element: <WeaknessSessionPage /> },
      { path: "/app/weakness", element: <Navigate to="/app/review" replace /> },
      { path: "/app/profile", element: <ProfilePage /> },
      { path: "/app/achievements", element: <AchievementsPage /> },
    ],
  },
  { path: "/", element: <RootRedirect /> },
  { path: "*", element: <NotFoundPage /> },
]);
